import axios from "axios";
import Swal from "sweetalert2";

export const baseURL = "https://distributorhub.danabooks.in/api/v1";

const api = axios.create({
  baseURL,
});

api.interceptors.request.use(
  (config) => {
    //   const token = getAuthToken();
    //   if (token) {

    Swal.fire({
      title: "Loading....",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const token = sessionStorage.getItem("Authorization");
    const email = sessionStorage.getItem("email");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.Accept = "application/json";
      config.headers.identifier = `${email}`;
    }
    return config;
  },
  (error) => {
    Swal.close(); // close if request itself fails
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    Swal.close();
    return response;
  },
  (error) => {
    Swal.close(); // close spinner on error
    if (error.response && error.response.status === 401) {
      // token expired / invalid
      sessionStorage.clear(); // clear stale data
      window.location.href = "/"; // force redirect
    }
    return Promise.reject(error);
  }
);

export default api;
